var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserAvatarDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.91724,
    y: 2.90918,
    width: 26.1818,
    height: 25.9303,
    rx: 12.9652,
    fill: "#2E8267"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2256_1078",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 28,
    height: 27
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.91724,
    y: 2.90918,
    width: 26.1818,
    height: 25.9303,
    rx: 12.9652,
    fill: "#2E8267"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2256_1078)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7129 19.416H13.7478V22.7607H18.7129V19.416Z",
    fill: "#F9C2A7"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9519 21.8361C15.7001 22.1334 16.5202 22.3118 17.3254 22.3192C17.7863 22.3242 18.257 22.2647 18.7129 22.1854V19.418H13.7478V21.1473C14.0971 21.4545 14.5431 21.6726 14.9519 21.8361Z",
    fill: "#E6E6E6"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7101 13.2195C21.7275 13.0981 21.9405 12.8999 22.0347 12.833C22.2428 12.6843 22.4509 12.8379 22.5129 13.0312C22.5674 13.2046 22.5723 13.4003 22.5847 13.5787C22.6169 14.0173 22.5475 14.4484 22.3444 14.8448C22.2081 15.1099 21.995 15.3254 21.7423 15.4889C21.7423 15.4889 21.4698 15.6203 21.4153 15.318C21.4153 15.318 21.7101 13.2195 21.7101 13.217V13.2195Z",
    fill: "#F9C2A7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6655 13.4844C21.6779 13.3977 21.8315 13.2565 21.8959 13.2069C22.0445 13.1004 22.1957 13.2094 22.2378 13.3482C22.2774 13.472 22.2799 13.6108 22.2898 13.7396C22.3121 14.0543 22.2626 14.3615 22.1164 14.6439C22.0198 14.8322 21.8661 14.9883 21.6853 15.1048C21.6853 15.1048 21.4896 15.1989 21.4524 14.9834C21.4524 14.9834 21.663 13.4819 21.663 13.4795L21.6655 13.4844Z",
    fill: "#F9C2A7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6255 13.2195C10.6082 13.0981 10.3951 12.8999 10.301 12.833C10.0928 12.6843 9.88473 12.8379 9.82279 13.0312C9.76829 13.2046 9.76333 13.4003 9.75094 13.5787C9.71874 14.0173 9.78811 14.4484 9.99127 14.8448C10.1275 15.1099 10.3406 15.3254 10.5933 15.4889C10.5933 15.4889 10.8659 15.6203 10.9204 15.318C10.9204 15.318 10.6255 13.2195 10.6255 13.217V13.2195Z",
    fill: "#F9C2A7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6678 13.4844C10.6554 13.3977 10.5043 13.2565 10.4374 13.2069C10.2887 13.1004 10.1376 13.2094 10.0955 13.3482C10.0558 13.472 10.0533 13.6108 10.0434 13.7396C10.0211 14.0543 10.0707 14.3615 10.2169 14.6439C10.3135 14.8322 10.4671 14.9883 10.648 15.1048C10.648 15.1048 10.8437 15.1989 10.8809 14.9834C10.8809 14.9834 10.6703 13.4819 10.6703 13.4795L10.6678 13.4844Z",
    fill: "#F9C2A7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.877 13.6162C21.877 15.0011 21.6292 16.401 20.9553 17.6001C20.3657 18.6481 19.4837 19.488 18.5347 20.157C17.7642 20.6996 16.9392 21.3338 15.9655 21.257C14.9497 21.1753 14.1593 20.3379 13.4161 19.6838C12.373 18.7621 11.548 17.6199 11.0425 16.2746C10.7304 15.4446 10.5867 14.5106 10.5867 13.6187C10.5867 9.14168 13.1138 6.32715 16.2306 6.32715C19.3474 6.32715 21.8745 9.14168 21.8745 13.6187L21.877 13.6162Z",
    fill: "#F9C2A7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9013 24.2741L18.7123 22.6562H13.7472L7.55824 24.2741C7.55824 24.2741 4.6892 25.337 4.37207 28.6991H28.0874C27.7678 25.337 24.9013 24.2741 24.9013 24.2741Z",
    fill: "#F9C2A7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9013 24.2741L18.7123 22.6562L16.2296 25.9888L13.7472 22.6562L7.55824 24.2741C7.55824 24.2741 4.6892 25.337 4.37207 28.6991H28.0874C27.7678 25.337 24.9013 24.2741 24.9013 24.2741Z",
    fill: "#ED6C02"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9012 24.2745L20.3226 23.0778L16.2322 28.7019L12.1863 23.0679L7.56312 24.2769C7.56312 24.2769 4.69408 25.3398 4.37695 28.7019H28.0923C27.7727 25.3398 24.9062 24.2769 24.9062 24.2769L24.9012 24.2745Z",
    fill: "#595959"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9557 13.063C21.9557 13.063 21.034 17.369 17.9445 18.6078C17.9445 18.6078 17.558 19.5642 16.2771 19.5642C14.9962 19.5642 14.6097 18.6078 14.6097 18.6078C11.5177 17.369 10.5985 13.063 10.5985 13.063C10.3309 17.8819 13.797 19.9779 13.797 19.9779C15.6874 21.5239 16.2771 21.2588 16.2771 21.2588C16.2771 21.2588 16.8667 21.5239 18.7571 19.9779C18.7571 19.9779 22.1911 18.0256 21.9557 13.063Z",
    fill: "#1A1A1A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2301 17.171C16.2301 17.171 14.9517 16.782 14.6123 18.6105C14.6123 18.6105 14.2505 18.5634 13.6782 18.1051C13.6782 18.1051 14.5355 15.962 16.2301 17.171Z",
    fill: "#1A1A1A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3386 17.171C16.3386 17.171 17.6171 16.782 17.9565 18.6105C17.9565 18.6105 18.3182 18.5634 18.8905 18.1051C18.8905 18.1051 18.0333 15.962 16.3386 17.171Z",
    fill: "#1A1A1A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6014 13.0633C10.6014 13.0633 11.4289 8.02148 14.013 8.51699C14.013 8.51699 16.3494 9.97133 18.2967 8.48231C18.2967 8.48231 20.6603 8.40303 21.9561 13.0609C21.9561 13.0609 22.2807 8.09085 18.713 6.31938C18.713 6.31938 15.4128 4.79567 12.5884 7.06266C12.5884 7.06266 9.91262 9.17603 10.5989 13.0609L10.6014 13.0633Z",
    fill: "#1A1A1A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2296 28.6994L12.1837 23.0654L8.948 23.9103L13.0831 26.8214L12.0202 27.2897L13.9329 28.6994H16.2296Z",
    fill: "#1A1A1A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2307 28.7068L20.2791 23.0728L23.5148 23.9176L19.3797 26.8312L20.4401 27.2995L18.5299 28.7068H16.2307Z",
    fill: "#1A1A1A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAvatarDefault);
export default __webpack_public_path__ + "static/media/user-avatar-default.21a136482c672e85252d62b58fd92747.svg";
export { ForwardRef as ReactComponent };